<template>
    <div>
          <section-header />
        
          <section class="contact-section">
                  <div class="auto-container">
        
                      <!--Contact Info Tabs-->
                      <div class="contact-info-tabs">
                          <!--Product Tabs-->
                          <div class="contact-tabs c-tabs-box">
        
                              <!--Tab Btns-->
                              <ul class="tab-btns tab-buttons clearfix">
                                  <li data-tab="#contact-tab-one" class="tab-btn active-btn">{{ $t('view.contact.title-1') }}</li>
                              </ul>
        
                              <!--Tabs Container-->
                              <div class="tabs-content">
                                  <!--Tab / Active Tab-->
                                  <div class="tab active-tab" id="contact-tab-one">
                                      <div class="text">{{ $t('view.contact.text-1') }}</div>
                                      <div class="row clearfix">
                                          <!--Accordian Column-->
                                          <div class="accordian-column col-md-4 col-sm-12 col-xs-12">
                                              <div class="column-inner">
                                                  <!--Accordion Box-->
                                                  <ul class="accordion-box style-four">
        
                                                      <!--Block-->
                                                      <li class="accordion block active-block">
                                                          <div class="acc-btn active"><div class="icon-outer"><span class="icon icon-plus fa fa-angle-right"></span> </div>{{ $t('view.contact.title-2') }}</div>
                                                          <div class="acc-content current">
                                                              <div class="content">
                                                                  <ul class="info-list">
                                                                      <li><span class="icon flaticon-placeholder-3"></span><strong>{{ $t('common.address') }}:</strong> 6 rue de Coulanges, 94370 Sucy-en-Brie, FRANCE</li>
                                                                      <li><span class="icon flaticon-e-mail-envelope"></span><strong>{{ $t('common.email-us') }}:</strong><br> contact@bcom.eu</li>
                                                                      <li><span class="icon fa fa-clock-o"></span><strong>{{ $t('common.open-hours-label') }}:</strong><br> {{ $t('common.open-hours-value') }}</li>
                                                                  </ul>
                                                              </div>
                                                          </div>
                                                      </li>
        
                                                  </ul>
                                              </div>
                                          </div>
                                          <!--Form Column-->
                                          <div class="form-column col-md-8 col-sm-12 col-xs-12">
                                              <!-- Contact Form -->
                                              <div class="contact-form ">
                                                  <h2>Message</h2>
                                                  <!--Comment Form-->
                                                  <div class="contact-page-form-1">
                                                      <div class="row clearfix">
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="name" value="" :placeholder="$t('common.contact-form.your-name')" required="" v-model="messageName">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="email" name="email" value="" :placeholder="$t('common.contact-form.email')" required="" v-model="messageEmail">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="number" value="" :placeholder="$t('common.contact-form.phone')" required="" v-model="messagePhone">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="text" value="" :placeholder="$t('common.contact-form.company')" required="" v-model="messageCompany">
                                                          </div>
                                                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                              <textarea placeholder="Message" v-model="messageText"></textarea>
                                                          </div>
                                                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                              <button class="theme-btn btn-style-one" v-on:click="sendMessage()">
                                                                <span v-if="sendMessageLoading" class="spinner-border text-light mt-3" role="status"></span>
                                                                <div v-if="sendMessageLoading">{{ $t('common.contact-form.please-wait') }}</div>
                                                                <div v-if="!sendMessageLoading">{{ $t('common.contact-form.submit') }}</div>
                                                              </button>
                                                          </div>
                                                      </div>
                                                  </div>
        
                                              </div>
                                              <!--End Comment Form -->
                                          </div>
                                      </div>
        
                                  </div>
        
                                  <!--Tab / Active Tab-->
                                  <div class="tab" id="contact-tab-two">
        
                                      <div class="text">We recently helped a small business grow from break-even to over $1m profit in less than 2 years. Please find below contact details and contact us today! Our experts always ready to help you. </div>
                                      <div class="row clearfix">
                                          <!--Accordian Column-->
                                          <div class="accordian-column col-md-4 col-sm-12 col-xs-12">
                                              <div class="column-inner">
                                                  <!--Accordion Box-->
                                                  <ul class="accordion-box style-four">
        
                                                      <!--Block-->
                                                      <li class="accordion block active-block">
                                                          <div class="acc-btn active"><div class="icon-outer"><span class="icon icon-plus fa fa-angle-right"></span> </div>Corporate Office</div>
                                                          <div class="acc-content current">
                                                              <div class="content">
                                                                  <ul class="info-list">
                                                                      <li><span class="icon flaticon-placeholder-3"></span><strong>Address:</strong> 321, Breaking Street, 2nd cros st, Newyork ,USA 10002</li>
                                                                      <li><span class="icon flaticon-telephone"></span><strong>Call Us:</strong><br> +321 4567 89 012 & 79 023</li>
                                                                      <li><span class="icon flaticon-e-mail-envelope"></span><strong>Mail Us:</strong><br> contact@bcom.eu</li>
                                                                      <li><span class="icon fa fa-clock-o"></span><strong>Opening Time:</strong><br> Mon - Sat: 09.00 to 18.00</li>
                                                                  </ul>
                                                              </div>
                                                          </div>
                                                      </li>
        
                                                      <!--Block-->
                                                      <li class="accordion block">
                                                          <div class="acc-btn"><div class="icon-outer"><span class="icon icon-plus fa fa-angle-right"></span> </div>Regional Office</div>
                                                          <div class="acc-content">
                                                              <div class="content">
                                                                  <ul class="info-list">
                                                                      <li><span class="icon flaticon-placeholder-3"></span><strong>Address:</strong> 321, Breaking Street, 2nd cros st, Newyork ,USA 10002</li>
                                                                      <li><span class="icon flaticon-telephone"></span><strong>Call Us:</strong><br> +321 4567 89 012 & 79 023</li>
                                                                      <li><span class="icon flaticon-e-mail-envelope"></span><strong>Mail Us:</strong><br> contact@bcom.eu</li>
                                                                      <li><span class="icon fa fa-clock-o"></span><strong>Opening Time:</strong><br> Mon - Sat: 09.00am to 18.00pm</li>
                                                                  </ul>
                                                              </div>
                                                          </div>
                                                      </li>
        
                                                  </ul>
                                              </div>
                                          </div>
                                          <!--Form Column-->
                                          <div class="form-column col-md-8 col-sm-12 col-xs-12">
                                              <!-- Contact Form -->
                                              <div class="contact-form ">
                                                  <h2>Send Message Us</h2>
                                                  <!--Comment Form-->
                                                  <div class="contact-page-form-2">
                                                      <div class="row clearfix">
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="name" value="" placeholder="Your Name" required="" v-model="messageName">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="email" name="email" value="" placeholder="Email Address" required="" v-model="messageEmail">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="number" value="" placeholder="Phone Number" required="" v-model="messagePhone">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="text" value="" placeholder="Company" required="" v-model="messageCompany">
                                                          </div>
                                                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                              <textarea placeholder="Message" v-model="messageText"></textarea>
                                                          </div>
                                                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                              <button class="theme-btn btn-style-one" v-on:click="sendMessage()">
                                                                <span v-if="sendMessageLoading" class="spinner-border text-light mt-3" role="status"></span>
                                                                <div v-if="sendMessageLoading">Please wait ...</div>
                                                                <div v-if="!sendMessageLoading">Submit</div>
                                                              </button>
                                                          </div>
                                                      </div>
                                                  </div>
        
                                              </div>
                                              <!--End Comment Form -->
                                          </div>
                                      </div>
        
                                  </div>
        
                                  <!--Tab / Active Tab-->
                                  <div class="tab" id="contact-tab-three">
        
                                      <div class="text">We recently helped a small business grow from break-even to over $1m profit in less than 2 years. Please find below contact details and contact us today! Our experts always ready to help you. </div>
                                      <div class="row clearfix">
                                          <!--Accordian Column-->
                                          <div class="accordian-column col-md-4 col-sm-12 col-xs-12">
                                              <div class="column-inner">
                                                  <!--Accordion Box-->
                                                  <ul class="accordion-box style-four">
        
                                                      <!--Block-->
                                                      <li class="accordion block active-block">
                                                          <div class="acc-btn active"><div class="icon-outer"><span class="icon icon-plus fa fa-angle-right"></span> </div>Corporate Office</div>
                                                          <div class="acc-content current">
                                                              <div class="content">
                                                                  <ul class="info-list">
                                                                      <li><span class="icon flaticon-placeholder-3"></span><strong>Address:</strong> 321, Breaking Street, 2nd cros st, Newyork ,USA 10002</li>
                                                                      <li><span class="icon flaticon-telephone"></span><strong>Call Us:</strong><br> +321 4567 89 012 & 79 023</li>
                                                                      <li><span class="icon flaticon-e-mail-envelope"></span><strong>Mail Us:</strong><br> contact@bcom.eu</li>
                                                                      <li><span class="icon fa fa-clock-o"></span><strong>Opening Time:</strong><br> Mon - Sat: 09.00am to 18.00pm</li>
                                                                  </ul>
                                                              </div>
                                                          </div>
                                                      </li>
        
                                                      <!--Block-->
                                                      <li class="accordion block">
                                                          <div class="acc-btn"><div class="icon-outer"><span class="icon icon-plus fa fa-angle-right"></span> </div>Regional Office</div>
                                                          <div class="acc-content">
                                                              <div class="content">
                                                                  <ul class="info-list">
                                                                      <li><span class="icon flaticon-placeholder-3"></span><strong>Address:</strong> 321, Breaking Street, 2nd cros st, Newyork ,USA 10002</li>
                                                                      <li><span class="icon flaticon-telephone"></span><strong>Call Us:</strong><br> +321 4567 89 012 & 79 023</li>
                                                                      <li><span class="icon flaticon-e-mail-envelope"></span><strong>Mail Us:</strong><br> contact@bcom.eu</li>
                                                                      <li><span class="icon fa fa-clock-o"></span><strong>Opening Time:</strong><br> Mon - Sat: 09.00am to 18.00pm</li>
                                                                  </ul>
                                                              </div>
                                                          </div>
                                                      </li>
        
                                                  </ul>
                                              </div>
                                          </div>
                                          <!--Form Column-->
                                          <div class="form-column col-md-8 col-sm-12 col-xs-12">
                                              <!-- Contact Form -->
                                              <div class="contact-form ">
                                                  <h2>Send Message Us</h2>
                                                  <!--Comment Form-->
                                                  <div class="contact-page-form-3">
                                                      <div class="row clearfix">
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="name" value="" placeholder="Your Name" required="" v-model="messageName">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="email" name="email" value="" placeholder="Email Address" required="" v-model="messageEmail">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="number" value="" placeholder="Phone Number" required="" v-model="messagePhone">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="text" value="" placeholder="Company" required="" v-model="messageCompany">
                                                          </div>
                                                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                              <textarea placeholder="Message" v-model="messageText"></textarea>
                                                          </div>
                                                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                              <button class="theme-btn btn-style-one" v-on:click="sendMessage()">
                                                                <span v-if="sendMessageLoading" class="spinner-border text-light mt-3" role="status"></span>
                                                                <div v-if="sendMessageLoading">Please wait ...</div>
                                                                <div v-if="!sendMessageLoading">Submit</div>
                                                              </button>
                                                          </div>
                                                      </div>
                                                  </div>
        
                                              </div>
                                              <!--End Comment Form -->
                                          </div>
                                      </div>
        
                                  </div>
        
                                  <!--Tab / Active Tab-->
                                  <div class="tab" id="contact-tab-four">
        
                                      <div class="text">We recently helped a small business grow from break-even to over $1m profit in less than 2 years. Please find below contact details and contact us today! Our experts always ready to help you. </div>
                                      <div class="row clearfix">
                                          <!--Accordian Column-->
                                          <div class="accordian-column col-md-4 col-sm-12 col-xs-12">
                                              <div class="column-inner">
                                                  <!--Accordion Box-->
                                                  <ul class="accordion-box style-four">
        
                                                      <!--Block-->
                                                      <li class="accordion block active-block">
                                                          <div class="acc-btn active"><div class="icon-outer"><span class="icon icon-plus fa fa-angle-right"></span> </div>Corporate Office</div>
                                                          <div class="acc-content current">
                                                              <div class="content">
                                                                  <ul class="info-list">
                                                                      <li><span class="icon flaticon-placeholder-3"></span><strong>Address:</strong> 321, Breaking Street, 2nd cros st, Newyork ,USA 10002</li>
                                                                      <li><span class="icon flaticon-telephone"></span><strong>Call Us:</strong><br> +321 4567 89 012 & 79 023</li>
                                                                      <li><span class="icon flaticon-e-mail-envelope"></span><strong>Mail Us:</strong><br> contact@bcom.eu</li>
                                                                      <li><span class="icon fa fa-clock-o"></span><strong>Opening Time:</strong><br> Mon - Sat: 09.00am to 18.00pm</li>
                                                                  </ul>
                                                              </div>
                                                          </div>
                                                      </li>
        
                                                      <!--Block-->
                                                      <li class="accordion block">
                                                          <div class="acc-btn"><div class="icon-outer"><span class="icon icon-plus fa fa-angle-right"></span> </div>Regional Office</div>
                                                          <div class="acc-content">
                                                              <div class="content">
                                                                  <ul class="info-list">
                                                                      <li><span class="icon flaticon-placeholder-3"></span><strong>Address:</strong> 321, Breaking Street, 2nd cros st, Newyork ,USA 10002</li>
                                                                      <li><span class="icon flaticon-telephone"></span><strong>Call Us:</strong><br> +321 4567 89 012 & 79 023</li>
                                                                      <li><span class="icon flaticon-e-mail-envelope"></span><strong>Mail Us:</strong><br> contact@bcom.eu</li>
                                                                      <li><span class="icon fa fa-clock-o"></span><strong>Opening Time:</strong><br> Mon - Sat: 09.00am to 18.00pm</li>
                                                                  </ul>
                                                              </div>
                                                          </div>
                                                      </li>
        
                                                  </ul>
                                              </div>
                                          </div>
                                          <!--Form Column-->
                                          <div class="form-column col-md-8 col-sm-12 col-xs-12">
                                              <!-- Contact Form -->
                                              <div class="contact-form ">
                                                  <h2>Send Message Us</h2>
                                                  <!--Comment Form-->
                                                  <div class="contact-page-form-4">
                                                      <div class="row clearfix">
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="name" value="" :placeholder="$t('common.contact-form.your-name')" required="" v-model="messageName">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="email" name="email" value="" :placeholder="$t('common.contact-form.email')" required="" v-model="messageEmail">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="number" value="" :placeholder="$t('common.contact-form.phone')" required="" v-model="messagePhone">
                                                          </div>
                                                          <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                              <input type="text" name="text" value="" :placeholder="$t('common.contact-form.company')" required="" v-model="messageCompany">
                                                          </div>
                                                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                              <textarea placeholder="Message" v-model="messageText"></textarea>
                                                          </div>
                                                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                              <button class="theme-btn btn-style-one" v-on:click="sendMessage()">
                                                                <span v-if="sendMessageLoading" class="spinner-border text-light mt-3" role="status"></span>
                                                                <div v-if="sendMessageLoading">{{ $t('common.contact-form.please-wait') }}</div>
                                                                <div v-if="!sendMessageLoading">{{ $t('common.contact-form.submit') }}</div>
                                                              </button>
                                                          </div>
                                                      </div>
                                                  </div>
        
                                              </div>
                                              <!--End Comment Form -->
                                          </div>
                                      </div>
        
                                  </div>
        
                              </div>
                          </div>
                      </div>
        
        
                  </div>
              </section>
        
    </div>
</template>

<script>
import EmailService from '../services/email.service';
import SectionHeader from '@/components/SectionHeader.vue';

export default {
  name: 'Contact',
  components: {
    SectionHeader
  },
  data() {
    return {
      messageName: '',
      messageEmail: '',
      messagePhone: '',
      messageCompany: '',
      messageSubject: 'Message',
      messageText: '',

      sendMessageLoading: false,
    };
  },
  mounted() {

  },
  methods: {
  sendMessage() {
    this.sendMessageLoading = true;
    EmailService.send(this.messageName, this.messageEmail, this.messageSubject, this.messagePhone, this.messageCompany, this.messageText).then(
      response => {
        this.sendMessageLoading = false;
        this.$root.$emit("send-message", "success");
      },
      error => {
        this.sendMessageLoading = false;
        var content =
                  (error.response && error.response.data && error.response.data.message) ||
                  error.message ||
                  error.toString();
        this.$root.$emit("send-message", "failure");
      }
    );
  }
}
};
</script>